import React from 'react';

interface AlertMessageProps {
  variant?: 'error' | 'info' | 'success';
  children: React.ReactNode;
}

const VARIANT_STYLES: Record<NonNullable<AlertMessageProps['variant']>, string> = {
  error: 'bg-red-600/20 border-red-500 text-red-200',
  info: 'bg-blue-600/20 border-blue-500 text-blue-200',
  success: 'bg-green-600/20 border-green-500 text-green-200',
};

const AlertMessage: React.FC<AlertMessageProps> = ({ variant = 'info', children }) => {
  return (
    <div
      role="alert"
      className={`rounded border px-4 py-3 text-sm sm:text-base break-words ${VARIANT_STYLES[variant]}`}
    >
      {children}
    </div>
  );
};

export default AlertMessage;
